import { render } from "./ChangeMonetizeButton.vue?vue&type=template&id=38b09018"
import script from "./ChangeMonetizeButton.vue?vue&type=script&lang=js"
export * from "./ChangeMonetizeButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__